(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-oke-reviews-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dac-cart-reassurance')) {
    customElements.define('dac-cart-reassurance', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected || this.events) return;
          this.events = new AbortController();
          const options = { signal: this.events.signal };
          this.addEventListener('click', event => {
            if (!event.target.closest('[data-dac-cart-reviews]') || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            const reviewsOpener = document.querySelector('.oke-reviewsTab[role="button"]');
            if (reviewsOpener) {
              event.preventDefault();
              reviewsOpener.click();
            }
          }, options);
          const dialog = this.querySelector('.dac-cart-trust__dialog');
          const opener = this.querySelector('[data-dac-spill-open]');
          if (dialog && opener && typeof dialog.showModal === 'function') {
            opener.hidden = false;
            this.addEventListener('click', event => {
              if (event.target.closest('[data-dac-spill-open]')) {
                if (!dialog.open) dialog.showModal();
              }
              if (event.target.closest('[data-dac-spill-close]')) dialog.close();
              if (event.target === dialog) {
                const bounds = dialog.getBoundingClientRect();
                if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
              }
            }, options);
            dialog.addEventListener('close', () => {
              if (opener.isConnected) opener.focus({ preventScroll: true });
            }, options);
          }
        });
      }
      disconnectedCallback() {
        if (this.events) this.events.abort();
        this.events = null;
        const dialog = this.querySelector('.dac-cart-trust__dialog');
        if (dialog && dialog.open) dialog.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dac-drill-finder-entry"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.dac-drill-entry a[data-mv-preserve-preview]').forEach(link => {
  const preservePreview = () => {
    const url = new URL(link.href, location.href), current = new URL(location.href);
    if (url.origin !== location.origin) return;
    const theme = window.Shopify?.theme;
    if (!current.searchParams.has('preview_theme_id') && ['unpublished','development'].includes(String(theme?.role).toLowerCase()) && /^\d+$/.test(String(theme?.id))) current.searchParams.set('preview_theme_id', String(theme.id));
    ['preview_theme_id','_ab','_fd','_sc'].forEach(key => { if (current.searchParams.has(key)) url.searchParams.set(key,current.searchParams.get(key)); });
    link.href = url.href;
  };
  preservePreview();
  link.addEventListener('click', preservePreview);
  if (!link.hasAttribute('data-drill-product')) return;
  const form = link.closest('.product_content_wrapper')?.querySelector('form.js-product-form');
  if (form?.dataset.productId !== link.dataset.drillProduct) return;
  const syncVariant = () => {
    const variant = form.querySelector('[name="id"]')?.value;
    if (!/^[0-9]+$/.test(variant || '')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin) return;
    url.searchParams.set('variant', variant);
    link.href = url.href;
  };
  ['pointerdown','focus','click','auxclick'].forEach(event => link.addEventListener(event, syncVariant));
  form.addEventListener('change', syncVariant);
  syncVariant();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dac-pdp-design-system"] && !Shopify.designMode) return;
  try {
    (() => {
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const initialized = new WeakSet();
    const shine = panel => {
      if (reducedMotion.matches || !panel.isConnected || panel.classList.contains('dac-jewel-shining')) return;
      panel.classList.add('dac-jewel-shining');
      setTimeout(() => panel.classList.remove('dac-jewel-shining'), 1350);
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting || entry.intersectionRatio < .6) return;
        observer.unobserve(entry.target);
        shine(entry.target);
      });
    }, { threshold: .6, rootMargin: '0px 0px -24px 0px' }) : null;
    const init = () => {
      document.querySelectorAll('#MainContent .product-quality-list').forEach(panel => {
        if (initialized.has(panel)) return;
        initialized.add(panel);
        observer?.observe(panel);
        panel.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse' && matchMedia('(hover: hover) and (pointer: fine)').matches) shine(panel);
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
    document.addEventListener('shopify:section:load', init);
    reducedMotion.addEventListener('change', () => {
      if (reducedMotion.matches) document.querySelectorAll('.dac-jewel-shining').forEach(panel => panel.classList.remove('dac-jewel-shining'));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dac-skip-link"] && !Shopify.designMode) return;
  try {
    document.querySelector('.dac-skip-link')?.addEventListener('click', (event) => {
    const main = document.getElementById('MainContent');
    if (!main) return;
    event.preventDefault();
    // A permanent tabindex on main breaks Safari's Back scroll restoration.
    main.setAttribute('tabindex', '-1');
    const releaseFocusTarget = () => {
      main.removeAttribute('tabindex');
      main.removeEventListener('blur', releaseFocusTarget);
      window.removeEventListener('pagehide', releaseFocusTarget);
    };
    main.addEventListener('blur', releaseFocusTarget, { once: true });
    window.addEventListener('pagehide', releaseFocusTarget, { once: true });
    main.focus({ preventScroll: true });
    main.scrollIntoView({ block: 'start', behavior: 'instant' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dac-specialty-finish-system"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dac-diamond-finish')) {
    class DacDiamondFinish extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.dac-finish-trigger');
        this.card = this.querySelector('.dac-finish-card');
        if (!this.trigger || !this.card || this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.nativePopover = typeof this.card.showPopover === 'function';
        this.pinned = false;
        if (this.nativePopover) this.card.hidden = false;
        this.trigger.addEventListener('click', event => {
          event.preventDefault();
          clearTimeout(this.openTimer);
          clearTimeout(this.closeTimer);
          if (this.opened && this.pinned) this.close(true);
          else { this.pinned = true; this.open(); }
        }, options);
        this.trigger.addEventListener('pointerenter', event => {
          clearTimeout(this.closeTimer);
          if (event.pointerType !== 'mouse' || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          this.openTimer = setTimeout(() => this.open(), 160);
        }, options);
        this.trigger.addEventListener('pointerleave', () => this.scheduleClose(), options);
        this.card.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), options);
        this.card.addEventListener('pointerleave', () => this.scheduleClose(), options);
        this.card.querySelector('.dac-finish-card__close').addEventListener('click', event => {
          event.preventDefault();
          this.close(true);
        }, options);
        this.card.addEventListener('beforetoggle', event => {
          const opening = event.newState === 'open';
          this.trigger.setAttribute('aria-expanded', String(opening));
          this.card.toggleAttribute('data-open', opening);
          if (!opening) { this.pinned = false; clearTimeout(this.openTimer); clearTimeout(this.closeTimer); }
        }, options);
        this.addEventListener('focusout', () => {
          clearTimeout(this.closeTimer);
          this.closeTimer = setTimeout(() => { if (!this.contains(document.activeElement) && !this.pinned) this.close(); }, 180);
        }, options);
        document.addEventListener('pointerdown', event => {
          if (!this.nativePopover && this.opened && !this.contains(event.target)) this.close();
        }, options);
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.opened) { event.preventDefault(); this.close(this.contains(document.activeElement)); }
        }, options);
        window.addEventListener('resize', () => this.position(), options);
        window.addEventListener('scroll', () => this.position(), { ...options, passive: true });
      }
      get opened() { return this.card?.hasAttribute('data-open'); }
      open() {
        if (!this.isConnected || this.opened) return;
        document.querySelectorAll('dac-diamond-finish').forEach(other => { if (other !== this) other.close?.(); });
        if (this.nativePopover) this.card.showPopover();
        else { this.card.hidden = false; this.card.setAttribute('data-open', ''); this.trigger.setAttribute('aria-expanded', 'true'); }
        this.position();
      }
      scheduleClose() {
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => {
          if (!this.pinned && !this.contains(document.activeElement) && !this.trigger.matches(':hover') && !this.card.matches(':hover')) this.close();
        }, 220);
      }
      close(restoreFocus = false) {
        clearTimeout(this.openTimer);
        clearTimeout(this.closeTimer);
        if (!this.opened) return;
        if (this.nativePopover) this.card.hidePopover();
        else { this.card.hidden = true; this.card.removeAttribute('data-open'); this.trigger.setAttribute('aria-expanded', 'false'); }
        this.pinned = false;
        if (restoreFocus && this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
      }
      position() {
        if (!this.opened) return;
        const anchor = this.trigger.getBoundingClientRect();
        const viewport = window.visualViewport;
        const leftEdge = viewport?.offsetLeft || 0;
        const topEdge = viewport?.offsetTop || 0;
        const width = viewport?.width || window.innerWidth;
        const height = viewport?.height || window.innerHeight;
        if (anchor.bottom < topEdge || anchor.top > topEdge + height) { this.close(); return; }
        const card = this.card.getBoundingClientRect();
        const left = Math.min(Math.max(anchor.left, leftEdge + 16), leftEdge + width - card.width - 16);
        let top = anchor.bottom + 8;
        if (top + card.height > topEdge + height - 16) top = anchor.top - card.height - 8;
        top = Math.max(topEdge + 16, Math.min(top, topEdge + height - card.height - 16));
        this.card.style.left = `${left}px`;
        this.card.style.top = `${top}px`;
      }
      disconnectedCallback() {
        clearTimeout(this.openTimer); clearTimeout(this.closeTimer);
        this.controller?.abort(); this.controller = null;
      }
    }
    customElements.define('dac-diamond-finish', DacDiamondFinish);
  }
  } catch(e) { console.error(e); }
})();

})();
